import React from 'react'
import bindAll from 'lodash.bindall'
import XesEventHanlder from './xes-event-handler'
import message from 'antd/lib/message/index'
import hook from './hooks'
import mblock from '../mblock-sdk'
// import { closeWindowFunction } from './common'
import xesBridge from 'xes-code-base/lib/libs/xes'
import { getXesEnvHanlder, isProjectTemplate, isNeedSaveAssets } from './xes.js'
import { connect } from 'react-redux'
import {
  XesLoadingState,
  resetLoadingState,
  setXesProjectMeta,
  resetXesProjectMeta,
  onXESConfirmSubmit
} from '../../reducers/project-state'
import { postAssets, disableSafariScale } from './xes-lib.js'
import SmartCtrl from './smart-ctrl.js'

const xesHoc = WrappedComponent => {
  class XesComponent extends React.Component {
    constructor(props) {
      super(props)
      bindAll(this, ['closeClassWork', 'initListener'])
      this.handler = getXesEnvHanlder()
      this.xesEnvHandler = new XesEventHanlder(getXesEnvHanlder())
      this.initListener()
    }
    componentDidMount() {
      disableSafariScale()
      this.handler.init(this.props.state, this.props.dispatch)
    }
    componentDidUpdate(preProps) {
      let {
        xesProjectMeta,
        xesLoadingState,
        projectTitle,
        projectWasLoaded
      } = this.props

      if (xesLoadingState === XesLoadingState.XES_RESET) {
        return
      }

      if (!projectWasLoaded) {
        return
      }
      if (xesProjectMeta) {
        if (
          [
            XesLoadingState.XES_RESET,
            XesLoadingState.XES_INITING,
            undefined
          ].includes(xesLoadingState)
        ) {
          return
        }
        if (xesLoadingState === XesLoadingState.XES_UPLOAD_DONE) {
          this.props.resetXesProjectMeta()
          return
        }
        if (xesProjectMeta) {
          let id = null,
              original_id = null
          // 如果是模板或者可以改编的作品，且未保存为自己的作品
          if(isProjectTemplate(xesProjectMeta.category) && !xesProjectMeta._adapt){
              id = null
              original_id = xesProjectMeta.id
          }else{ // 保存为自己的作品
              id = xesProjectMeta.id
              original_id = xesProjectMeta.original_id
          }
          let name = projectTitle || xesProjectMeta.name || '我的作品'

          let params = Object.assign({}, this.props.xesProjectMeta, {
            id,
            original_id,
            name,
            version: 'hw1.0',
            xml: mblock.getCode(),
            thumbnail: mblock.getCover()
          })
          if (isNeedSaveAssets(xesLoadingState)) {
            postAssets(mblock.getAssets())
              .then(() => {
                this.xesEnvHandler.handle(xesLoadingState, params)
              })
              .catch(() => {
                window.alert('保存资源失败')
              })
          } else {
            this.xesEnvHandler.handle(xesLoadingState, params)
          }
        }
        this.props.resetLoadingState()
      }
    }
    initListener() {
      let { state, dispatch } = this.props
      hook.addHook(hook.types.AFTER_SAVE, data => {
        this.props.setXesProjectMeta(data)
      })
      hook.addHook(hook.types.AFTER_SUBMIT, data => {
        this.props.setXesProjectMeta(data)
        this.handler.onDoneSubmit(state, dispatch, data)
      })
      var showCheckInfo = function(data,isSendLog) {
        try {
          /* 显示控制头 */
          SmartCtrl.showCtrlHeader()
            document.getElementsByTagName('iframe')[0]
              .contentWindow.renderCheckResult(data,isSendLog)
            document.getElementsByTagName('iframe')[0].style.display = 'block'
            function setIframeHeight(iframe) {
              if (iframe) {
                var iframeWin =
                  iframe.contentWindow || iframe.contentDocument.parentWindow
                if (iframeWin.document.body) {
                  iframe.height =
                    iframeWin.document.documentElement.scrollHeight ||
                    iframeWin.document.body.scrollHeight
                }
              }
            }
            //    iframe高度自适应
            setIframeHeight(document.getElementsByTagName('iframe')[0])
            window.hideIframe = function() {
              document.getElementsByTagName('iframe')[0].style.display = 'none'
            }
        } catch (error) {
          console.log(error);
        }
      }
      hook.addHook(hook.types.AFTER_CHECK, data => {
        //localStorage.setItem('checkData', JSON.stringify(data) );
        if (data.data) {
          SmartCtrl.setCheck(data)
        }
        showCheckInfo(data,true)
      })

      hook.addHook(hook.types.AFTER_CHECK_BACKGROUND, data => {
        // 服务器错误 500等 继续提交
        console.log(
          "this.props.xesBackgroundCheckType",
          this.props.xesBackgroundCheckType
        );
        if (data == null){
            if (this.props.xesBackgroundCheckType === 'submit'){
                dispatch(onXESConfirmSubmit())
            }
            return
        }
        if (data.data && data.data.data.result === 'success' ) {
            // 没有问题直接提交
            if(this.props.xesBackgroundCheckType === 'submit'){
                dispatch(onXESConfirmSubmit())
                SmartCtrl.setSubmit(data)
            }
        }else{
            if(this.props.xesBackgroundCheckType === 'submit'){
                showCheckInfo(data,false)
                SmartCtrl.setSubmit(data)
            }else{
                SmartCtrl.doTimingDetection(data.data)
            }
        }
      })
    }
    closeClassWork() {
      xesBridge.closeWindowFunction()
    }
    render() {
      const {
        xesLoadingState,
        xesBackgroundCheckType,
        getCode,
        assets,
        initialAssets,
        xesProjectId,
        resetLoadingState,
        xesProjectMeta,
        rendereronXESSubmit,
        setXesProjectMeta,
        resetXesProjectMeta,
        ...componentProps
      } = this.props;
      return <WrappedComponent {...componentProps} />
    }
  }

  const mapStateToProps = state => {
    const xesLoadingState = state.scratchGui.xesProjectState.xesLoadingState
    return {
      xesLoadingState,
      xesBackgroundCheckType: state.scratchGui.xesProjectState.xesBackgroundCheckType,

      projectWasLoaded: state.scratchGui.xesProjectState.isLoaded,
      xesProjectId: state.scratchGui.xesProjectState.xesProjectId,
      xesProjectMeta: state.scratchGui.xesProjectState.xesProjectMeta,
      state,
      projectTitle: state.scratchGui.projectTitle
    }
  }
  const mapDispatchToProps = dispatch => ({
    resetLoadingState: () => dispatch(resetLoadingState()),
    setXesProjectMeta: projectMeta => dispatch(setXesProjectMeta(projectMeta)),
    resetXesProjectMeta: () => dispatch(resetXesProjectMeta()),
    dispatch
  })
  return connect(
    mapStateToProps,
    mapDispatchToProps
  )(XesComponent)
}
export default xesHoc
